import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-selector-card',
  templateUrl: './selector-card.component.html',
  styleUrls: ['./selector-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectorCardComponent {
  @Input() label = ''
  @Input() prefix = ''
  @Input() value: string | null | undefined = ''
  @Input() icon = 'calendar-light'
  @Input() extraClasses = ''
  @Input() capitalizeLabel = false
  @Input() showArrow = true
  @Input() showLabel = true
}
